const Footer = () => {
  return (
    <footer className="bg-foreground py-16 px-6">
      <div className="mx-auto max-w-7xl text-center">
        <h3 className="text-2xl font-display font-light text-primary-foreground">
          Love Otherwise
        </h3>
        <div className="mx-auto mt-4 h-px w-12 bg-champagne" />
        <p className="mt-6 text-xs tracking-[0.2em] uppercase font-body text-primary-foreground/50">
          A space for all love stories
        </p>
        <p className="mt-8 text-xs tracking-[0.3em] uppercase font-body text-primary-foreground/40">
          London · Ontario · Canada
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-3">
          {[
            { label: "Home", href: "/" },
            { label: "About Us", href: "/about" },
            { label: "The Gallery", href: "/gallery" },
            { label: "Packages", href: "/packages" },
            { label: "Love Notes Blog", href: "/blog" },
            { label: "Contact Us", href: "/contact" },
            { label: "Otherwise Creative", href: "https://www.otherwisecreative.co.uk", external: true },
            { label: "Admin", href: "/login" },
          ].map((item) => (
            <a
              key={item.label}
              href={item.href}
              target={(item as any).external ? "_blank" : undefined}
              rel={(item as any).external ? "noopener noreferrer" : undefined}
              className="text-xs tracking-[0.1em] uppercase font-body text-primary-foreground/40 hover:text-primary-foreground/80 transition-colors"
            >
              {item.label}
            </a>
          ))}
        </div>
        <p className="mt-12 text-xs font-body text-primary-foreground/30">
          © {new Date().getFullYear()} Otherwise Creative. All rights reserved.
        </p>
        <p className="mt-3 text-xs font-body text-primary-foreground/30">
          Site Design by{" "}
          <a href="https://www.shanarecker.com" target="_blank" rel="noopener noreferrer" className="hover:text-primary-foreground/60 transition-colors underline">
            Shana Recker
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
